import PageActionContext from '@stores/page-action-context';
import React, { useContext, useEffect } from 'react';

const PostEnquiryLandingNoInput = () => {
     const pageActionCxt = useContext(PageActionContext);

    useEffect(() => {
        if (pageActionCxt.isNextClicked) {
            const nextEventData = pageActionCxt.nextEventData;
            pageActionCxt.navigate(nextEventData.url, nextEventData.isExternal);
        }
    }, [pageActionCxt.isNextClicked]);

    return (
        <></>
    );
};

export default PostEnquiryLandingNoInput;
